import React, { useRef } from "react";
import { useVSU } from "../store";
import { streamLabel } from "../helpers";
import VideoPlayer from "./VideoPlayer";
import StreamsList from "./StreamsList";

// Секция «Просмотр видеопотока» (UC.12.01): выбор видеопотока (5.4), полноэкранный режим (5.6),
// область воспроизведения (5.5), перечень видеопотоков (5.7).
export default function VideoSection() {
  const { t, lang, items, selectedId, selectStream, selected } = useVSU();
  const playerRef = useRef(null);

  const empty = selectedId === null;
  const available = !!selected?.video?.available;

  // Полноэкранный режим (5.6): блокируется при пустой выборке и при недоступной записи.
  const fsDisabled = empty || !available;
  const fsReason = empty
    ? t("noSelection")
    : !available
    ? t("noVideoShort")
    : "";

  const goFullscreen = () => {
    const el = playerRef.current;
    if (el && el.requestFullscreen) el.requestFullscreen();
  };

  return (
    <>
      <div className="vsu-pick-row">
        <span className="vsu-ctrl-label">{t("pick")}</span>
        <select
          className="vsu-select vsu-stream-sel"
          value={selectedId ?? ""}
          disabled={empty}
          onChange={(e) => selectStream(Number(e.target.value))}
        >
          {empty ? (
            <option value="">—</option>
          ) : (
            items.map((s) => (
              <option key={s.id} value={s.id}>
                {streamLabel(s, lang)}
              </option>
            ))
          )}
        </select>
        <button
          className="vsu-pbtn"
          onClick={goFullscreen}
          disabled={fsDisabled}
          title={fsReason}
        >
          ⛶ {t("fullscreen")}
        </button>
      </div>

      <div className="vsu-view-grid">
        <VideoPlayer containerRef={playerRef} />
        <StreamsList />
      </div>
    </>
  );
}
